import {
  ActivityViewMode,
  Select,
  useAssetRegistry,
  useMediaMobileScreen,
} from "@cca/components";
import { ReactNode } from "react";

export type ActivityPlayerFooterProps = {
  children: ReactNode;
  currentPage?: number;
  totalPages?: number;
  pageLimit?: number;
  viewMode: ActivityViewMode;
  onPageChange?: (page: number) => void;
};

export const ActivityPlayerFooter = ({
  children,
  currentPage,
  totalPages,
  pageLimit,
  viewMode,
  onPageChange,
}: ActivityPlayerFooterProps) => {
  const pageOptions = [...Array(totalPages)].map((_, index) => {
    const number = index + 1;
    const value = number.toString();

    return {
      label: value,
      value,
      disabled:
        viewMode === "edit" &&
        (currentPage === undefined ||
          pageLimit === undefined ||
          (typeof pageLimit === "number" && number > pageLimit)),
    };
  });

  const selectedPageOption = currentPage
    ? pageOptions.find((option) => option.value === currentPage.toString())
    : undefined;

  const { validateAll } = useAssetRegistry();
  const isMobile = useMediaMobileScreen();

  return (
    <div className="flex h-16 w-full items-center border-t border-gray-100 px-4 md:justify-end md:px-6">
      <div className="flex gap-2 max-md:w-full max-md:justify-between md:gap-6">
        {!isMobile && totalPages && totalPages > 0 ? (
          <div className="flex items-center gap-1 font-medium text-gray-800">
            <label htmlFor="page-selector">Page</label>
            <Select
              inputId="page-selector"
              isMulti={false}
              isSearchable={false}
              menuPlacement="auto"
              menuPortalTarget={document.body}
              onChange={(option) => {
                if (!option) return;
                if (viewMode === "edit" && !validateAll()) return;

                const number = Number(option.value);
                onPageChange?.(number);
              }}
              options={pageOptions}
              placeholder="..."
              value={selectedPageOption}
            />
            <span className="whitespace-nowrap">of {totalPages ?? "..."}</span>
          </div>
        ) : null}
        {children}
      </div>
    </div>
  );
};
